'use strict';

// Be nice to IE11
if (typeof NodeList.prototype.forEach !== 'function')  {
	NodeList.prototype.forEach = Array.prototype.forEach;
}

// Cookie banner
const $cookieBanner = $('#js-cookie-info');
if ($cookieBanner.length) {
	const cookieState = Cookies.get('site_cookie_info');
	if (cookieState == 1) {
		$cookieBanner.remove();
	} else {
		$cookieBanner
			.hide()
			.removeClass('hidden')
			.slideDown(function() {
				const $cookieBannerButton = $('#js-cookie-info-button');
				$cookieBannerButton.on('click', function() {
					Cookies.set('site_cookie_info', '1', { expires: 7 })
					$cookieBanner.slideUp(function() {
						$(this).remove();
					});
				});
			});
	}
}

// Init off-canvas
var offCanvas = new OffCanvas({
	debug: false,
	overlay: true,
})

// Top list show/hide button
const $topListToggle = $('#js-top-list-toggle');
if ($topListToggle.length) {
	const $topList = $('#js-top-list');
	$topListToggle.on('click', function() {
		$topList.toggleClass('md:js-show');
		if ($topList.hasClass('md:js-show')) {
			$(this).find('.icon').addClass('icon-down-open').removeClass('icon-up-open');
		} else {
			$(this).find('.icon').removeClass('icon-down-open').addClass('icon-up-open');
		}
	});
}

// Accordions
const $accordions = $('.js-accordion-item');
if ($accordions.length) {
	$accordions.each(function() {
		const $accordionToggle = $(this).find('> button');
		const $accordionContent = $accordionToggle.next();
		$accordionToggle.on('click', function() {
			// $accordionToggle.next().slideToggle();
			$accordionContent.toggleClass('js-show');
			if ($accordionContent.hasClass('js-show')) {
				$accordionToggle.find('.icon').removeClass('icon-down-open').addClass('icon-up-open');
			} else {
				$accordionToggle.find('.icon').addClass('icon-down-open').removeClass('icon-up-open');
			}
		})
	});
}

// Form modal (Modaal)
$('.modal--inline').modaal({
	width: 1024,
	height: 768,
	overlay_close: false,
});

// Init union search
const unionSearch = new UnionSearch();

// Init event logger
const eventLogger = new EventLogger();
